import React from "react";
const Dropdown = (props) => {
  const { locations, getBlackoutDates } = props;
  const locationList = locations.map((x, index) => {
    return (
      <div
        key={index}
        style={{
          padding: "5px",
        }}
      >
        <div
          style={{
            cursor: "pointer",
            color: "rgb(69, 72, 74)",
            fontWeight: "600",
          }}
          onClick={() => {
            getBlackoutDates(x);
          }}
        >
          {x.locationName}
        </div>
        <div style={{ fontSize: "12px" }}>
          {x.address}, {x.city}, {x.state}
        </div>
        <hr />
      </div>
    );
  });

  return (
    <div className="dropdown">
      <div className="dropdown-title">Locations</div>
      <div className="location-list">{locationList}</div>
    </div>
  );
};

export default Dropdown;
